import { useContext, useEffect, } from "react";

import { Button, useTheme, } from "@material-ui/core";
import { withUbdAnalyticsStep } from "@aspirasi/react-data-analytics";

import { StoreContext } from "../../../store/context";

import { APPLICATION_STATUS } from "../../../constants/applicationStatus";

import Header from "../../../components/Header";
import Footer from "../../../components/Footer";

import { useThemeStyles } from "../../../styles/themes";

import bannerPartnership2x from "../../../assets/images/partnershipConfirmation/banner-partnership@2x.png";
import checkedCircleOutlinedGreen from "../../../assets/images/checked-circle-outlined-green.svg";

import "./PartnershipConfirmation.scss";

const CheckedText = (props) => {
  const { text } = props;

  return (
    <div className="small" style={{ marginTop: "10px", display: "flex", gap: "8px", alignItems: "center" }}>
      <img src={checkedCircleOutlinedGreen} alt="checked-circle-outlined-green" />
      {text}
    </div>
  );
};

const PartnershipConfirmation = (props) => {
  const { currentStep, totalSteps, stepText, analyticsStep } = props;

  const classes = useThemeStyles();
  const theme = useTheme();
  const { state, actions } = useContext(StoreContext);

  const styles = {
    listTextBold: {
      fontWeight: 600,
      color: theme.colors.colorPrimaryGrey
    }
  };

  const benefits = state.isOnboardingUpdate ? [
    <p><span style={styles.listTextBold}>Same fees & charges</span> – no hidden costs</p>,
    <p>Split your transactions up to <span style={styles.listTextBold}>twelve (12) months</span> instalments</p>,
    <p>Get a <span style={styles.listTextBold}>lower rate</span>: 1.5% instead of 2.5%</p>
  ] : [
    <p><span style={styles.listTextBold}>No service fees</span> on your next three (3) transactions</p>,
    <p><span style={styles.listTextBold}>Same fees & charges</span> – no hidden costs</p>,
    <p>Split your transactions up to <span style={styles.listTextBold}>twelve (12) months</span> instalments</p>
  ];

  const handleAccept = () => {
    actions.setStep("StepAdditionalDetails");
  };

  const handleReject = () => {
    actions.updateOnboarding({
      applicationId: state.applicationId,
      changeFunderAction: APPLICATION_STATUS.REJECTED
    }).then(() => {
      actions.getDashboardUrl()
        .then((res) => {
          if (res.data?.redirectionUrl) {
            window.location.href = res.data?.redirectionUrl;
          }
        });
    });
  };

  useEffect(() => {
    if (state.prerequisites && state.lToken && !state.kycToken) {
      actions.getKycToken();
    }
  }, [state.prerequisites]);

  return (
    <>
      <Header />
      <div className="page page-partnership-confirmation" style={{ overflow: "hidden" }}>
        <div className={`${classes.customScrollbar} custom-scrollbar`}>
          <img src={bannerPartnership2x} alt="bannerPartnership2x" />

          <div className={`${classes.content} content`}>
            <div style={{ marginTop: "16px" }}>
              {/* <p className={`${classes.title} title`}>Boost PayFlex Just Got Better with Boost Bank!</p> */}
              <p className={`${classes.subtitle}`} style={{ fontWeight: 800 }}>Boost PayFlex Just Got Better with Boost Bank!</p>
              {/* <div className={`${classes.divider} divider`} /> */}
              <p className="small">We’re excited to introduce a new partnership with Boost Bank to help you get even more out of your Boost PayFlex experience.</p>
              <p className="small">Here’s what you’ll enjoy when you switch to Boost Bank as your financer for your Boost PayFlex transactions:</p>

              {benefits.map((benefit, index) => <CheckedText key={index} text={benefit} />)}
            </div>

            <div
              className="small"
              style={{
                borderRadius: "8px",
                backgroundColor: theme.colors.colorPrimaryLight,
                padding: "16px",
                marginTop: "24px",
              }}
            >
              <p style={{ fontWeight: 700 }}>NOTE:</p>
              <p>By choosing Boost Bank, your financing will <span style={{ fontWeight: 600, borderBottom: "0.5px solid" }}>no longer be Shariah-compliant</span>.
                If you’d prefer to keep financing with Boost Credit, you can simply choose to decline this offer.
              </p>
            </div>

            <div style={{ marginTop: "24px", display: "flex", flexDirection: "column", gap: "10px" }}>
              <p style={{ fontSize: "12px", color: theme.colors.colorPrimaryDarker }}>By tapping “Agree,” you consent to proceed with Boost Bank as your PayFlex financer</p>
              <Button
                className={`${classes.btnContained} btn-next`}
                variant="contained"
                color="primary"
                onClick={handleAccept}
                disabled={!state.kycToken}
                // type="submit"
              >
                Accept
              </Button>
              <Button
                className={`${classes.btnOutlinedSecondary} btn-next`}
                onClick={handleReject}
                disabled={!state.kycToken}
                // variant="outlined"
                // color="primary"
                // type="submit"
              >
                Reject
              </Button>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default withUbdAnalyticsStep(PartnershipConfirmation, {
  stepId: "PartnershipConfirmation",
  capturingFieldNames: []
});
